import React from "react";
import "./radio-button.scss";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
interface RadioButtonProps {
    checked: boolean;
    onChange: any;
    label?: string;
    name?: string;
    required?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({
    checked,
    onChange,
    label,
    name,
    required,
}) => {
    const { customerEnabled, customerCreated } = useAppSelector((state) => state.auth);
    const { projectReadOnly } = useAppSelector((state) => state.projectHeader);

    return (
        <div className="flex items-center space-x-2">
            <input
                type="radio"
                checked={checked}
                onChange={onChange}
                disabled={(customerEnabled && !customerCreated) || projectReadOnly}
                className="accent-primary-600 outline-none border-[1px] border-darkcolor-300 bg-darkcolor-800 h-[20px] w-[20px] appearance-none relative"
                name={name}
            />
            {label && <label className="text-white">{label}</label>}
            {required && <span className="text-error-400 ml-1">*</span>}
        </div>
    );
};

export default RadioButton;
